export default function getResource(label) {
    const resources = {
        noProducts: 'Désolé, aucun article ne correspond aux filtres appliqués.',
        showMore: 'Show more',
        showLess: 'Show less'
    };

    return resources[label];
}
